const quoteObj = [
  {
    quote:
      "The shoe that fits one person pinches another; there is no recipe for living that suits all cases.",
    author: "Carl Jung",
    authorLink: "https://share.google/HaMdwI6YFnRdnoOlF",
    otherLink: "https://youtu.be/2AMu-G51yTY?si=DwkS067T812lP9-k",
  },
  {
    quote: "Reality is merely an illusion, albeit a very persistent one.",
    author: "Albert Einstein",
    authorLink: "https://share.google/99zeHmTVZBSWJoMaJ",
    otherLink: "https://www.bbc.co.uk/programmes/m001qdx1",
  },
  {
    quote:
      "These individuals have riches just as we say that we “have fever”, when really the fever has us.",
    author: "Seneca",
    authorLink: "https://en.wikipedia.org/wiki/Seneca_the_Younger",
    otherLink: "https://youtu.be/waq9S6kaTlU?si=CKnFiLLIg-vSvpim",
  },
  {
    quote:
      "What you want, wants you too. Just get out of the way and let it come through.",
    author: "Bronnie Ware",
    authorLink: "https://share.google/bUNTM7xdp6ivCEgNH",
    otherLink: "https://youtu.be/dVnsOkM4PcA?si=6frwINqn82YnnJf8",
  },
  {
    quote:
      "It is not enough to take steps which may some day lead to a goal; each step must be itself a goal and a step likewise.",
    author: "Johann Wolfgang von Goethe",
    authorLink: "https://share.google/GS7pXBZREUYN4QBhP",
    otherLink: "",
  },
  {
    quote:
      "Freedom can be best defined as the opportunity for self-discipline.",
    author: "Dwight D. Eisenhower",
    authorLink: "https://share.google/CchJMsxJtePhQoUqe",
    otherLink: "",
  },
  {
    quote: "Tis easier to know how to speak than how to be silent",
    author: "Thomas Fuller",
    authorLink: "https://en.wikipedia.org/wiki/Thomas_Fuller",
    otherLink: "",
  },
  {
    quote:
      "We must each find our separate meaning, the persuasion of our days, until we meet in the meaning of the world",
    author: "Christopher Fry",
    authorLink: "https://share.google/liqYcWCOOkhcp5xEC",
    otherLink: "",
  },
  {
    quote:
      "Meanings change amazingly. When people get accustomed to horrors, these form the foundation for good style",
    author: "Boris Pasternack",
    authorLink: "https://share.google/ZpB1vxbjDKjx6hI4m",
    otherLink: "",
  },
  {
    quote:
      "The meaning of things lies not in the things themselves, but in our attitude towards them",
    author: "Saint Exupery ",
    authorLink: "https://share.google/pAKY5JLD5YQ2tT2UM",
    otherLink: "https://share.google/wwKRES9D4a3v0nzV2",
  },
  {
    quote: "The mind knows no answers. The heart knows no questions.",
    author: "Buddha",
    authorLink: "https://share.google/WscF3RT2rVzJRytqC",
    otherLink: "",
  },
  {
    quote: "Life loves the one who dares to live it.",
    author: "Maya Angelou",
    authorLink: "https://share.google/2NjfmWchKSg5C5ZCY",
    otherLink: "https://youtu.be/1ZD8KhoZrp4?si=Fgf6tLW4TB_5agcO",
  },
  {
    quote:
      "Freedom suppressed and again regained bites with keener fangs then freedom never endangered.",
    author: "Cicero",
    authorLink: "https://share.google/uikrle2BFbYEPTTd0",
    otherLink: "",
  },
  {
    quote:
      "A man that is young in years may be old in hours, if he have lost no time.",
    author: "Francis Bacon",
    authorLink: "https://share.google/whS1KBomXjMUZh182",
    otherLink: "",
  },
  {
    quote:
      "We do but learn to-day what our better advanced judgements will unteach us tomorrow.",
    author: "Sir Thomas Browne",
    authorLink: "https://share.google/q0ofLeLeZr8ZpHm8l",
    otherLink: "",
  },
  {
    quote: "We cannot all do everything.",
    author: "Virgil",
    authorLink: "https://share.google/1U2hMBm6USsOjkg8y",
    otherLink: "",
  },
  {
    quote:
      "I never saw an ugly thing in my life, for let the form of an object be what it may - light, shade, perspective, will always make it beautiful.",
    author: "John Constable",
    authorLink: "https://share.google/HLWXYtBG9S3Hazbv6",
    otherLink: "https://youtu.be/-lM1NraAbW4?si=CVr-39AKIV-ZfDld",
  },
  {
    quote:
      "As some point in life, the worlds beauty becomes enough. You don't need to photograph, paint or even remember it - it is enough.",
    author: "Toni Morrison",
    authorLink: "https://share.google/yqoEla0aUajyGE9qY",
    otherLink: "https://youtu.be/eSLbTtMiEzY?si=YVE5xfZjpNsQggJK",
  },
  {
    quote: "Suit the action to the word, the word to the action.",
    author: "William Shakespeare",
    authorLink: "https://share.google/c7dlSqhYQBxXfW7Ev",
    otherLink: "https://youtu.be/TsJ9gucPmjA?si=wCr7NlHrTdGjo9y-",
  },
  {
    quote: "Better to light a candle than curse the darkness.",
    author: "Peter Benenson",
    authorLink: "https://en.wikipedia.org/wiki/Peter_Benenson",
    otherLink: "https://www.amnesty.org/en/",
  },
  {
    quote:
      "Get the advice of everybody whose advice is worth having - they are very few - and then do what you think best yourself.",
    author: "Charles Stewart Parnell",
    authorLink: "https://share.google/sdMqfAIBBdf5E3Yc1",
    otherLink: "",
  },
  {
    quote:
      "All ambitions are lawful except those which climb upwards on the miseries or credulities of mankind.",
    author: "Joseph Conrad",
    authorLink: "https://share.google/A59gd2JK5x2FrCFlq",
    otherLink: "",
  },
  {
    quote: "There is nothing worse than a brilliant beginning.",
    author: "Pablo Picasso",
    authorLink: "https://share.google/S62Jd07Obrv15bZ5Y",
    otherLink: "https://share.google/lCIZX1bao7KcBkl5z",
  },
  {
    quote:
      "He that will not apply new remedies must expect new evils; for time is the greatest innovator.",
    author: "Francis Bacon",
    authorLink: "https://share.google/whS1KBomXjMUZh182",
    otherLink: "",
  },
  {
    quote: "You can’t step twice into the same river.",
    author: "Heraclitus",
    authorLink: "https://share.google/tMaNrD9iEhbhu4Npt",
    otherLink: "https://youtu.be/xm3wVSi-vNQ?si=SAvrj-zVRYVQrPRI",
  },
  {
    quote:
      "Mr Bond, they have a saying in Chicago, ‘Once is happenstance. Twice is coincidence. The third time is enemy action.",
    author: "Goldfinger",
    authorLink: "https://share.google/jdrS4kJ1qmIH4NsEH",
    otherLink: "",
  },
  {
    quote: "A man's character is his fate.",
    author: "Heraclitus",
    authorLink: "https://share.google/tMaNrD9iEhbhu4Npt",
    otherLink: "https://youtu.be/xm3wVSi-vNQ?si=SAvrj-zVRYVQrPRI",
  },
  {
    quote:
      "A propensity to hope and joy is real riches; one to fear and sorry, real poverty.",
    author: "David Hume",
    authorLink: "https://share.google/lwL7xQ1RJXNzahP4J",
    otherLink: "https://youtu.be/HS52H_CqZLE?si=y2HObcW8aZw_Z01F",
  },
  {
    quote:
      "Action is consolatory. It is the enemy of thought and the friend of flattering illusions.",
    author: "Joseph Conrad",
    authorLink: "https://share.google/A59gd2JK5x2FrCFlq",
    otherLink: "",
  },
  {
    quote:
      "It is of no consequence what other people think of you. What matters is what you think of them.",
    author: "Gore Vidal",
    authorLink: "https://share.google/lgF3XK1LbdBhslFqv",
    otherLink: "https://youtu.be/Nb1w_qoioOk?si=UYY6Be3jdFfu_5w3",
  },
  {
    quote:
      "There is no despair so absolute as that which comes with the first moments of our first great sorrow, when we have not yet know what is it to have suffered and be healed, to have despaired and have recovered.",
    author: "George Eliot",
    authorLink: "https://share.google/OdXlWG0xVwaTPKhdL",
    otherLink: "https://www.poetryfoundation.org/poets/george-eliot",
  },
  {
    quote:
      "Look for what's missing. Many advisers can tell a president how to improve what's proposed, or what's gone amiss. Few are able to see what isn't there.",
    author: "Donald Rumsfeld",
    authorLink: "https://share.google/X8YMMdRx3XSe6Rc3u",
    otherLink: "",
  },
  {
    quote: "A deception that elevates us is dearer than a host of low truths.",
    author: "Alexander Pushkin",
    authorLink: "https://share.google/XSjfyIscTa9OabHfd",
    otherLink: "",
  },
  {
    quote: "Dangers, by deing despised, grow great.",
    author: "Edmund Burke",
    authorLink: "https://share.google/XhIA0frvh8fS9V8NU",
    otherLink: "",
  },
  {
    quote:
      "I maintain that two and two would continue to make four, in spite of the whine of the amateur for three, or the cry of the critic for five.",
    author: "James McNeil Whistler",
    authorLink: "https://share.google/pvdLJ9qNUoWWlzIJG",
    otherLink: "https://youtu.be/7h0fcRkK44Q?si=X4UmIaJDrJZMDm2a",
  },
  {
    quote:
      "A thing itself never expresses anything. It is the relation between things that gives meaning to them and formulates a thought. A thought functions only as a fragmentary part in the formulation of an idea",
    author: "Hans Hofmann",
    authorLink: "https://share.google/Igq7ZHz2IrJZF7r6k",
    otherLink: "https://youtu.be/TQ-AgQZBqoQ?si=3Tif8zlyXca5P1T4",
  },
  {
    quote:
      "Someone to tell it to is one of the fundamental needs of human beings.",
    author: "Miles Franklin",
    authorLink: "https://share.google/vpzwb4JJby9s0HRY8",
    otherLink: "",
  },
  {
    quote: "A good conscience is a continual christmas.",
    author: "Benjamin Franklin",
    authorLink: "https://share.google/co5DZAwAKQo8eAVmn",
    otherLink: "",
  },
  {
    quote:
      "O pure and noble conscience, how bitter a sting to thee is a little fault.",
    author: "Dante",
    authorLink: "https://share.google/riRlU5Hmc6T3EZo45",
    otherLink: "",
  },
  {
    quote:
      "The means prepare the end, and the end is what the means have made it.",
    author: "John Morley",
    authorLink: "https://share.google/l1zVEkMGuMn84uLA7",
    otherLink: "",
  },
  {
    quote:
      "A good man would prefer to be defeated than to defeat injustice by evil means.",
    author: "Sallust",
    authorLink: "https://en.wikipedia.org/wiki/Sallust",
    otherLink: "",
  },
  {
    quote: "Reality is merely an illusion, albeit a very persistent one.",
    author: "Albert Einstein",
    authorLink: "https://share.google/99zeHmTVZBSWJoMaJ",
    otherLink: "https://www.bbc.co.uk/programmes/m001qdx1",
  },
  {
    quote:
      "Our consciousness is not actually yours of mine, it is the consciousness of man evolved, grown, accumulated through many, many centuries. [...] When one realises this, our responsibility becomes extraordinarily important.",
    author: "Krishamurti",
    authorLink: "https://share.google/dF0OpEmMBuSX7Oo6x",
    otherLink: "https://youtu.be/8-Ab948czOY?si=_VEUQVhCEPbRemzM",
  },
  {
    quote: "There are thousands of lives in one single life.",
    author: "Swami Prajnanpad",
    authorLink: "https://share.google/ymUt12xqsVhrN2gxT",
    otherLink: "",
  },
  {
    quote:
      "If most of us remain ignorant of ourselves, it is becaused self-knowledge is painful and we prefer the pleasures of illusion.",
    author: "Aldous Huxley",
    authorLink: "https://share.google/R6OPlSdoBP6ZdysiM",
    otherLink: "",
  },
  {
    quote:
      "If you see the soul in every living being, you see truly. If you see the immortality in the heart of every mortal being, you see truly.",
    author: "The Bhagavad Gita",
    authorLink: "https://en.wikipedia.org/wiki/Bhagavad_Gita",
    otherLink: "",
  },
  {
    quote: "To free oneself from knowledge is to die, and thus one lives.",
    author: "Krishamurti",
    authorLink: "https://share.google/dF0OpEmMBuSX7Oo6x",
    otherLink: "https://youtu.be/8-Ab948czOY?si=_VEUQVhCEPbRemzM",
  },
  {
    quote:
      "Journalist: 'What do you think of modern civilisation?'. Ghandi: 'I think it would be a good idea.'",
    author: "Mahatma Gandhi",
    authorLink: "https://share.google/kZYlRxy5fsKk4hmt3",
    otherLink: "",
  },
  {
    quote: "He not busy being born is busy dying.",
    author: "It's Alright, Ma (I'm Only Bleeding) - Bob Dylan",
    authorLink: "https://share.google/phAK92t6EFmHQDfNN",
    otherLink: "",
  },
  {
    quote:
      "Most of the change we think we see in life is due to truths being in and out of favor.",
    author: "Robert Frost",
    authorLink: "https://share.google/xXx3OhROwcX6c4m22",
    otherLink: "",
  },
  {
    quote:
      "Consistentcy is contrary to nature, contrary to life. The only completely consistent people are the dead.",
    author: "Aldous Huxley",
    authorLink: "https://share.google/R6OPlSdoBP6ZdysiM",
    otherLink: "",
  },
  {
    quote:
      "God, give us the serenity to accept what cannot be changed. Give us the courage to change what should be changed. Give us the wisdom to distinguish one from the other.",
    author: "Reinhold Niebuhr",
    authorLink: "https://share.google/BLtEfwmt7vXY7m5ta",
    otherLink: "",
  },
  {
    quote:
      "Anger in its time and place, may assume a kind of grace. It must have some reason in it, and not last beyond a minute.",
    author: "Charles Lamb",
    authorLink: "https://share.google/X85rVOkfGiG6x2Y3O",
    otherLink: "",
  },
  {
    quote:
      "What we call the beginning is often the end and to make an end is to make a beginning. The end is where we start from.",
    author: "T.S. Eliot",
    authorLink: "https://share.google/TpX1Zj3HD2g9wAB7f",
    otherLink: "",
  },
  {
    quote:
      "Ah, what a dusty answer gets the soul when hot for certainties in this our life",
    author: "George Meredith",
    authorLink: "https://share.google/NWayFx6LYWLOGNHfK",
    otherLink: "",
  },
  {
    quote:
      "Doubt may be an uncomfortable position, but certainty is a ridiculous one.",
    author: "Voltaire",
    authorLink: "https://share.google/lPoZc7o4L4PY1mT5x",
    otherLink: "https://en.wikipedia.org/wiki/Candide",
  },
  {
    quote: "The absent are always in the wrong.",
    author: "Philippe Nericaut Destouches",
    authorLink: "https://share.google/5LMJ7mQPOJCfyXcLn",
    otherLink: "",
  },
  {
    quote:
      "The first principle is that you must not fool yourself, and you are the easiest person to fool.",
    author: "Richard P. Feynman",
    authorLink: "https://share.google/0BrxQulQCDcUL1c0q",
    otherLink: "",
  },
  {
    quote:
      "He has, indeed, done it very well; but it is a foolish thing well done.",
    author: "Samuel Johnson",
    authorLink: "https://share.google/9WGhW0unqZ8OHCvMy",
    otherLink: "",
  },
  {
    quote: "Fame is an accident; merit a thing absolute.",
    author: "Herman Melville",
    authorLink: "https://share.google/sLy8VqydDvNfsDgxv",
    otherLink: "",
  },
  {
    quote:
      "The perfect way is only difficult for those who pick and choose. Do not like, do not dislike; all will then be clear. Make a hair breadths difference and all heaven and earth are set apart. If you wnat the truth to stand clear before you, never be for or against.",
    author: "Sen Zhong",
    authorLink: "https://en.wikipedia.org/wiki/Shen_Zhong",
    otherLink: "",
  },
  {
    quote:
      "The primary job of artists is to create places within which you can have feelings.",
    author: "Brian Eno",
    authorLink: "https://share.google/6zLUUFHVGVOIidn69",
    otherLink: "",
  },
  {
    quote: "Art is meant to distub; science to reassure.",
    author: "Georges Braque",
    authorLink: "https://share.google/EUEC2l2TaDcP4dxuX",
    otherLink: "",
  },
  {
    quote:
      "When you have a creative gift, it is like someone has given you a horse. You either learn to ride it, or it kills you.",
    author: "Jerry Seinfeld",
    authorLink: "https://share.google/PgNFpLeEdDIYcti32",
    otherLink: "",
  },
  {
    quote:
      "We must all face the choice between what is right and what is easy.",
    author: "Albus Dumbledore",
    authorLink: "https://share.google/v7PbrydHvad8GAEMf",
    otherLink: "",
  },
  {
    quote: "In the Ant's House, the dew is the flood.",
    author: "Persian Proverb",
    authorLink: "",
    otherLink: "",
  },
  {
    quote:
      "It is of no consequence what other people think of you. What matters is what you think of them.",
    author: "Gore Vidal",
    authorLink: "https://share.google/lgF3XK1LbdBhslFqv",
    otherLink: "https://youtu.be/Nb1w_qoioOk?si=UYY6Be3jdFfu_5w3",
  },
  {
    quote:
      "Give nobody's heart pain so long as thou canst avoid it, for one sigh may set a whole world into a flame.",
    author: "Saadi Shirazi (1258)",
    authorLink: "https://share.google/UJW2VFhwuXx96ReXM",
    otherLink: "",
  },
  {
    quote: "Men are cruel, but Man is kind.",
    author: "Rabindranath Tagore",
    authorLink: "https://share.google/VLJLdXUOVXLl6OK6U",
    otherLink: "",
  },
  {
    quote: "Men are cruel, but Man is kind.",
    author: "Rabindranath Tagore",
    authorLink: "https://share.google/VLJLdXUOVXLl6OK6U",
    otherLink: "",
  },
  {
    quote: "Everyone appears as buddhas in the eyes of the buddha.",
    author: "Buddhist Saying",
    authorLink: "",
    otherLink: "",
  },
  {
    quote: "Action should culminate in wisdom.",
    author: "Bhagavad gita",
    authorLink: "https://en.wikipedia.org/wiki/Bhagavad_Gita",
    otherLink: "",
  },
  {
    quote:
      "Action springs not from thought, but from a readiness for responsibility.",
    author: "Dietrich Bonhoeffer",
    authorLink: "https://share.google/vdzXIIpXhE5hezPQt",
    otherLink: "",
  },
  {
    quote: "Don't just do something. Sit there.",
    author: "Zen Proverb",
    authorLink: "",
    otherLink: "",
  },
  {
    quote: "Act quickly, think slowly.",
    author: "Greek Proverb",
    authorLink: "",
    otherLink: "",
  },
  {
    quote:
      "Act only on that maxim whereby you can at the same time will that it should become a universal law.",
    author: "Immanuel Kant",
    authorLink: "https://share.google/J3Xw4vQv9svpUsNnk",
    otherLink: "",
  },
  {
    quote:
      "We cannot withdraw our cards from the game. Were we as silent and as mute as stones, our very passivity would be an act.",
    author: "Jean-Paul Sartre",
    authorLink: "https://share.google/Hy7Gman0ITTrklTXB",
    otherLink: "https://youtu.be/3bQsZxDQgzU?si=R3eI4dbWQISbdtJL",
  },
  {
    quote: `"I am ashamed of my emptiness," said the Word to the Work. "I know how poor I am when I see you," said the Work to the Word.`,
    author: "Rabindranath Tagore",
    authorLink: "https://share.google/VLJLdXUOVXLl6OK6U",
    otherLink: "",
  },
  {
    quote: `Being happy means being able to look inside oneself without alarm.`,
    author: "Walter Benjamin",
    authorLink: "https://share.google/AF4FYSSBouRO3pGIs",
    otherLink: "https://youtu.be/WqsyvK_2eYo?si=Pv9pO4SAgX0kJNBa",
  },
  {
    quote: `[...] everyone is committed to the optical illusions of his own isolated standpoint.`,
    author: "Walter Benjamin",
    authorLink: "https://share.google/AF4FYSSBouRO3pGIs",
    otherLink: "https://youtu.be/WqsyvK_2eYo?si=Pv9pO4SAgX0kJNBa",
  },
  {
    quote: `All human relationships having any degree of intimacy are under assualt from an almost unbearably piercing clarity such as they can scarcely withstand. This is because on the one hand money, devastatingly, forms the focal point of all life's interests, while on the other hand that same thing is the barrier that brings nearly every human relationship up short; in consequence, things that are disappearing more and more from both the natural and moral worlds are unthinking trust, peace, and good health.`,
    author: "Walter Benjamin",
    authorLink: "https://share.google/AF4FYSSBouRO3pGIs",
    otherLink: "https://youtu.be/WqsyvK_2eYo?si=Pv9pO4SAgX0kJNBa",
  },
  {
    quote: `No one, nowadays, should stick rigidly to what he or she 'can' do. Strength lies in improvisation. The blows that count are all landed with the left.`,
    author: "Walter Benjamin",
    authorLink: "https://share.google/AF4FYSSBouRO3pGIs",
    otherLink: "https://youtu.be/WqsyvK_2eYo?si=Pv9pO4SAgX0kJNBa",
  },
  {
    quote: `Most of the luxuries, and many of the so-called comforts of life, are not only not indispensable, but positive hindrances to the elevation of mankind.`,
    author: "Henry David Thoreau",
    authorLink: "https://share.google/powMdflsDGYDXwqEH",
    otherLink: "https://youtu.be/JJL9S0J8-4k?si=1xZhtWn_7HBpUhCl",
  },
  {
    quote: `Our ego could be pictured as a leaking balloon, forever requiring the helium of external love to remain inflated and vulnerable to the smallest pinpricks of neglect. There is something sobering and absurd in the extend to which we are cheered by attention and damaged by disregard. Our mood may blacken because a colleague has greet us absent-mindedly and our calls having been left unanswered. And we are capable of finding life worth living because someone has remembered our name and sent us a fruit basket.`,
    author: "Alain de Botton",
    authorLink: "https://share.google/m8pxIpyoq0zEbsBYB",
    otherLink: "https://youtu.be/A02Ucd6monY?si=4LKwwEQO11OPzJBn",
  },
  {
    quote: `The price we have paid for expecting to be so much more than our ancestors is a perpetual anxiety that we are far from being all we might be.`,
    author: "Alain de Botton",
    authorLink: "https://share.google/m8pxIpyoq0zEbsBYB",
    otherLink: "https://youtu.be/gC5hAAvhClE?si=LEhjKpmkCc8sUfMl",
  },
  {
    quote: `It's not my place in society that makes me well off, but my judgements; and these I can carry with me [...] These are my own and can't be taken away.`,
    author: "Epictetus",
    authorLink: "https://share.google/UNzFdqEWFnISpq0DZ",
    otherLink: "https://youtu.be/KnFxKECY3Ck?si=u93gCQgwssvZ2Mi4",
  },
  {
    quote: `When Alexander the Great passed through Corinth, he visited the philosopher Diogenes and found him sitting under a tree, dressed in rags, with no money to his name. Alexander, the most powerful man in the world, asked if he could do anything to help him. "Yes," replied the philosopher, "if you could step out of the way. You are blocking the sun.". Alexander's soliders were horrified, expecting an outburst of their commander's famous anger. But Alexander, only laughed and remarked that if he were not Alexander, he would certainly like to be Diogenes.`,
    author: "Greek Story",
    authorLink: "",
    otherLink: "",
  },
  {
    quote: `Wealth and poverty do not lie in a person's estate, but in their souls.`,
    author: "Antisthenes",
    authorLink: "https://share.google/djESW767zxJjIj5GP",
    otherLink: "https://youtu.be/jzg5sFDcUQk?si=ZefWw2VMRu7B77ZO",
  },
  {
    quote: `There is no wealth but life; life including all its powers of love, joy and of admiration. That country is richest which nourishes the greatest number of noble and happy human beings.`,
    author: "John Ruskin",
    authorLink: "https://share.google/HlXfoCK2kBdwaE9zt",
    otherLink: "https://youtu.be/x40l1ov8hfA?si=X-7zAY97uibF88-Z",
  },
  {
    quote: `What nature requires is obtainable, and within easy reach. It's for the superfluous that we sweat.`,
    author: "Seneca",
    authorLink: "https://en.wikipedia.org/wiki/Seneca_the_Younger",
    otherLink: "https://youtu.be/waq9S6kaTlU?si=CKnFiLLIg-vSvpim",
  },
  {
    quote: `Possessions are generally diminished by possession.`,
    author: "Friedrich Nietzsche",
    authorLink: "https://share.google/3iA30tHVerJqI9Nvu",
    otherLink: "https://youtu.be/wHWbZmg2hzU?si=yJAEvFw-btRAqfxi",
  },
  {
    quote: `Many a man would rather you heard his story than granted his request.`,
    author: "Lord Chesterfield",
    authorLink:
      "https://en.wikipedia.org/wiki/Philip_Stanhope,_4th_Earl_of_Chesterfield",
    otherLink: "",
  },
  {
    quote: `The animal needing something knows how much it needs, the man does not.`,
    author: "Democritus of Abdera",
    authorLink: "https://share.google/JlKWY8pPgvySBGlGD",
    otherLink: "",
  },
  {
    quote: `A life, admirable at first sign, may have cost so much in imposed liabilities, chores and self-abasement, that, brilliant though it appears, it cannot be considered as other than a failure. Another, which seems to have misfired, is in reality a triumphant success, because it cost so little. .`,
    author: "Henry de Montherlant",
    authorLink: "https://share.google/gtQ3QUnJtU6m9iLyd",
    otherLink: "",
  },
  {
    quote: `The most universal quality is diversity.`,
    author: "Michel de Montaigne",
    authorLink: "https://share.google/Td7i9x78HiJm4ap1B",
    otherLink: "https://youtu.be/ncmeYUWvvAU?si=45ZTAn3MN7wHRi8X",
  },
  {
    quote: `Does the cell, moving freely in the pond or in our body, seek its food?
    Is there some modicum of mind in it? That is a question natural to ask. It is not decisively answerable.`,
    author: "Sir Charles Sherrington",
    authorLink: "https://share.google/PbmNuQKhC6uFwwgjU",
    otherLink: "https://youtu.be/0YVUkGdxckk?si=20m1uhJxgad7NEPM",
  },
  {
    quote: `The most accomplished monkey cannot draw a monkey, this too only a human can do; just as it is also only man who regards his ability to do this as a distinct merit.`,
    author: "Georg Christoph Lichtenberg",
    authorLink: "https://share.google/1dUZBzpwbJqtL3emB",
    otherLink: "",
  },
  {
    quote: `How do you know but ev'ry Bird that cuts the airy way, Is an immense world of delight, clos'd by your senses five.`,
    author: "William Blake",
    authorLink: "https://share.google/U3VYAtW8SYIh49WPr",
    otherLink: "https://youtu.be/grxnTX9jm4E?si=QM3NKM3WIdf-W1Or",
  },
  {
    quote: `Man considers the actions, but God weighs the intentions.`,
    author: "Thomas à Kempis",
    authorLink: "",
    otherLink: "",
  },
  {
    quote: `All religions promise a reward for excellences of the will or heart, but none for excellences of the head or understanding.`,
    author: "Arthur Schopenhauer",
    authorLink: "https://share.google/b2bgrrpcSUL7ezSJO",
    otherLink: "https://youtu.be/q0zmfNx7OM4?si=I_9ReCYZFaijhmvp",
  },
  {
    quote: `All religions will pass, but this will remain: simply sitting in a chair and looking in the distance.`,
    author: "Vasily Rozanov",
    authorLink: "https://share.google/E261DX8R60Rskn7aR",
    otherLink: "",
  },
  {
    quote: `It is easier to know man in general than to understand one man in particular.`,
    author: "François de La Rochefoucauld",
    authorLink: "https://share.google/xkQeyZUUvgBGi3Xpo",
    otherLink: "https://youtu.be/3bjhteMkXpk?si=-yn2jnRrAjuiXraw",
  },
  {
    quote: `Man is a plant that bears thoughts, just as a rose-tree bears roses and an apple-tree bears apples.`,
    author: "Antoine Fabre D'Olivet",
    authorLink: "https://share.google/aRDLXCDltpg17eDBM",
    otherLink: "",
  },
  {
    quote: `We talk of wild animals; but an is the only wild animal. It is man that has broken out. All other animals are tame animals; following the rugged respectability of the tribe or type.`,
    author: "G. K. Chesterton",
    authorLink: "https://share.google/QfZuUoFernHx13BJF",
    otherLink: "",
  },
  {
    quote: `To say that man is made up of strength and weakness, of insight and blindness, of pettiness and grandeur, is not to draw an indictment against him; it is to define him.`,
    author: "Denis Diderot",
    authorLink: "https://share.google/R8F9qn4AIFsVV1QVZ",
    otherLink: "",
  },
  {
    quote: `Man's sensitivity to little things and insensitivity to the greatest are the signs of a strange disorder.`,
    author: "Blaise Pascal",
    authorLink: "https://share.google/1Tjdh2Hw9pkFlVL2U",
    otherLink: "https://youtu.be/3nb4nYqNXyM?si=QjcCYLR6Q_EDGTgw",
  },
  {
    quote: `The interest in life does not lie in what people do, nor even in their relations to each other, but largely in the power to communicate with a third party, antagonistic, enigmatic, yet perhaps persuadable, which one may call life itself.`,
    author: "Virginia Woolf",
    authorLink: "https://share.google/wSKa8Cs1czbskbAP3",
    otherLink: "https://youtu.be/DcMLkce_BLg?si=wbAON7qAvIs9BH69",
  },
  {
    quote: `I cling to imperfection, as the very essence of my being.`,
    author: "Anatole France",
    authorLink: "https://share.google/Se3mDla4krD6RlpTb",
    otherLink: "",
  },
  {
    quote: `People often say that this or that person has not yet found himself.
    But the self is not something one finds, it is something one creates.`,
    author: "Thomas Szasz",
    authorLink: "https://share.google/w7P6xTRx6qXhpLwvk",
    otherLink: "",
  },
  {
    quote: `The man of pleasure, by a vain attempt to be more happy than any man can be, is often more miserable than most men are.`,
    author: "Charles Caleb Colton",
    authorLink: "https://share.google/H9uegKGWc3H2s6slQ",
    otherLink: "",
  },
  {
    quote: `Gather ye rose buds while ye may, Old Time is still a-flying, and this same flower that smiles to-day To-morrow will be dying.`,
    author: "Robert Herrick",
    authorLink: "https://share.google/smzlJJBJH3fbyJMBj",
    otherLink: "https://youtu.be/ShRFc2yE5h4?si=mXCor3GXkrVgh48J",
  },
  {
    quote: `Actual happiness always looks pretty squalid in comparison with over-compensations for misery.`,
    author: "Brave New World: Aldous Huxley",
    authorLink: "https://en.wikipedia.org/wiki/Brave_New_World",
    otherLink: "",
  },
  {
    quote: `No scheme for a change of society can be made to appear immediately palatable, expect by falsehood, until society has become so desperate that it will accept any change.`,
    author: "T. S. Eliot",
    authorLink: "https://share.google/TpX1Zj3HD2g9wAB7f",
    otherLink: "",
  },
  {
    quote: `What man loses by the social contract is his natural liberty and an unlimited right to everything he tries to get and succeeds in getting; what he gains is civil liberty and the proprietorship of all he possesses.`,
    author: "Jean-Jacques Rousseau",
    authorLink: "https://share.google/xmvH76v2txlmk2TBS",
    otherLink: "",
  },
  {
    quote: `Nature holds no brief for the human experiment: it must stand or fall by its results.`,
    author: "George Bernard Shaw",
    authorLink: "https://share.google/atlNB0D0QhI9QOdOR",
    otherLink: "",
  },
  {
    quote: `Those people who have it made are only one step from being a has been.`,
    author: "Fred Shero",
    authorLink: "https://share.google/hQZDISphxGT62cvwT",
    otherLink: "",
  },
  {
    quote: `When you have something to prove, there is nothing greater than a challenge.`,
    author: "Terry Bradshaw",
    authorLink: "https://share.google/Sf1YBX212sdlBHgGr",
    otherLink: "",
  },
  {
    quote: `What is defeat? Nothing but education; nothing but the first step to something better.`,
    author: "Wendell Phillips",
    authorLink: "https://en.wikipedia.org/wiki/Wendell_Phillips",
    otherLink: "",
  },
  {
    quote: `Today I will do what others won't so tomorrow I can accomplish what others can't.`,
    author: "Jerry Rice",
    authorLink: "https://share.google/eD8S4mCZ6H67lEYm5",
    otherLink: "",
  },
  {
    quote: `As the saying goes, "the most exciting phrase to hear in science, the one that heralds new discoveries, is not 'Eureka!' but 'that's funny?'.`,
    author: "Anon",
    authorLink: "",
    otherLink: "",
  },
  {
    quote: `Congestion will always be a problem solvable more by planners and by overall demand than by the decisions of individual drivers, human or computer, selfish or cooperative.`,
    author: "Segment from Algorithms to Live By",
    authorLink: "https://share.google/bGT4InVBDZ2ZqCAEC",
    otherLink: "",
  },
  {
    quote: `I've run the gamut, A to Z, Three cheers and dammit, c'est la vie!.`,
    author: "I'm Still Here by Stephen Sondheim (Follies)",
    authorLink: "https://en.wikipedia.org/wiki/Follies",
    otherLink: "",
  },
  {
    quote: `When I do good I feel good, when I do bad I feel bad, and that's my religion.`,
    author: "Abraham Lincoln",
    authorLink: "https://share.google/PpQADUzHvAGWWWL9k",
    otherLink: "",
  },
  {
    quote: `Fighting for peace is like f**king for chastity.`,
    author: "George Carlin",
    authorLink: "https://share.google/wc8LHUa0H4ZSc4lKd",
    otherLink: "",
  },
  {
    quote: `Beauty is its own excuse for being.`,
    author: "Ralph Waldo Emerson",
    authorLink: "https://share.google/eoGxRdN3gnv1utFoT",
    otherLink: "",
  },
  {
    quote: `Oh, but now old friends, they're acting strange
And they shake their heads and they tell me that I've changed
Well, something's lost, but something's gained
In living every day.`,
    author: "Both Sides Now - Joni Mitchell",
    authorLink: "https://share.google/QoOxTRvxY6Q9yMLMz",
    otherLink: "https://youtu.be/jxiluPSmAF8?si=dW5ujj5jr2QGyzKa",
  },
  {
    quote: `I just want to be your friend, because I'd like our little drama to have a happy ending and finally be fear transcending.`,
    author: "I just want to be your friend - Millenium",
    authorLink:
      "https://genius.com/The-millennium-i-just-want-to-be-your-friend-lyrics",
    otherLink: "",
  },
  {
    quote: `Everyone has the same truth; they just speak it in a language that only a few understand..`,
    author: "Michaela Juby",
    authorLink: "https://www.instagram.com/michaela_juby/?hl=en",
    otherLink: "",
  },
  {
    quote: `Where your fear is, there is your task.`,
    author: "Carl Jung",
    authorLink: "https://share.google/HaMdwI6YFnRdnoOlF",
    otherLink: "https://youtu.be/2AMu-G51yTY?si=DwkS067T812lP9-k",
  },
  {
    quote: `You know what they say, "Some things in life are bad; They can really make you mad. Other things just make you swear and curse". When you're chewing on life's gristle, don't grumble, give a whistle; And this'll help things turn out for the best And...`,
    author: "Eric Idle",
    authorLink: "https://share.google/X0T9hr4v2eqMS1FVZ",
    otherLink: "https://youtu.be/SJUhlRoBL8M?si=JjAPhhdKr5irb4Yb",
  },
  {
    quote: `If life seems jolly rotten, there's something you've forgotten; and that's to laugh and smile and dance and sing. When you're feeling in the dumps, don't be silly chumps. Just purse your lips and whistle, that's the thing. And...`,
    author: "Eric Idle",
    authorLink: "https://share.google/X0T9hr4v2eqMS1FVZ",
    otherLink: "https://youtu.be/SJUhlRoBL8M?si=JjAPhhdKr5irb4Yb",
  },
  {
    quote: `After the ecstasy, the laundry. After the agony, the laundry.`,
    author: "Zen Proverb",
    authorLink: "",
    otherLink: "",
  },
  {
    quote: `There is no such thing as an elightened person; only enlightened actions.`,
    author: "Zen Insight",
    authorLink: "",
    otherLink: "",
  },
  {
    quote: `Ideally you are brave enough to walk right along the edge of the precipice and stay fully conscious. But everyone pulls back a little bit from time to time. But I think you have to know when you are pulling back from full participation in your life. As long as you are aware of your self-deception, you can go ahead and do it but you are not going to get away with it to yourself.`,
    author: "Edward Albee",
    authorLink: "https://share.google/6ItESozZRmnUqYDFy",
    otherLink: "",
  },
  {
    quote: `Refine your skills so you can support your instincts.`,
    author: "Linda Ronstadt",
    authorLink: "https://share.google/6dcv1Zoh6lt6HB3ds",
    otherLink: "",
  },
  {
    quote: `Win if you can, lose if you must - but find a way to get it done.`,
    author: "Marty Schottenheimer",
    authorLink: "https://share.google/ANHQMx0ykCf2aJHL3",
    otherLink: "",
  },
  {
    quote: `Make sure that something tonight is not taking you away from this moment man, because it's all we got. That's what you don't realise most of the time - we don't get this again. The clock runs too fast. That's why we've got to savour these moments, because they are right now. I couldn't understand that when I was 24 and 25.`,
    author: "Ray Lewis",
    authorLink: "https://share.google/p9I0jh5BZiwupuaDn",
    otherLink: "",
  },
  {
    quote: `Was the earth made to preserve a few covetous, proud men to live at ease; or as it made to preserve all her children.`,
    author: "Gerrard Winstanley, 1649",
    authorLink: "https://share.google/C9yMTHatqEJolaKZ6",
    otherLink: "",
  },
  {
    quote: `We are only trustees for those that come after us.`,
    author: "William Morris",
    authorLink: "https://share.google/2hCmJJTT0qt4aiiv8",
    otherLink: "https://youtu.be/QiNFoJqOJhs?si=r1NU6Yk1dxiEN9st",
  },
  {
    quote: `The multitudes are individually helpless against the rapacity of the few.`,
    author: "William Randolph Hearst",
    authorLink: "https://share.google/vUmpfLyZJL5cL1uc1",
    otherLink: "https://youtu.be/dJ3xIfKs3kA?si=BRM5UqlP9HeqyiEj",
  },
  {
    quote: `Sunday fails to satisfy, not because it is a day off work, but because its own promise is felt directly as unfulfilled.`,
    author: "Theodor Adorno",
    authorLink: "https://share.google/M6GNCux28HPZs2UL3",
    otherLink: "https://youtu.be/4YGnPgtWhsw?si=fPdiSXtwZMbvqogN",
  },
  {
    quote: `I write my plays to find out why I am writing them.`,
    author: "Edward Albee",
    authorLink: "https://share.google/6ItESozZRmnUqYDFy",
    otherLink: "https://youtu.be/jE3vwTrhNdY?si=cPaE3392iqSYz8Bw",
  },
  {
    quote: `He was such a cool person in the fact that he was really trying to make sure that I felt comfortable. When he was talking to me it felt like he was talking to his son.`,
    author: "Jamie Foxx (on Ray Charles)",
    authorLink: "https://share.google/7gLKrDTz4gFnnFtUZ",
    otherLink: "https://youtu.be/i2znPxfx7vo?si=O9srfz4ubl5ZCXVC",
  },
  {
    quote: `When you write a play, you should write the first play written by anyone.`,
    author: "Edward Albee",
    authorLink: "https://share.google/6ItESozZRmnUqYDFy",
    otherLink: "",
  },
  {
    quote: `[...] and when each day is the same as the next, it's because people fail to recognise the good things that happen in their lives every day as the sun rises.`,
    author: "Paulo Coelho",
    authorLink: "https://share.google/pA9xs4pcSQPgfld9G",
    otherLink: "https://youtu.be/keQZgd-sppk?si=YQoiNVIiREYyAeHy",
  },
  {
    quote: `Our journey is about being more deeply involved in life, yet less attached to it.`,
    author: "Ram Dass",
    authorLink: "https://share.google/p0JXnDYXfGy8jdaqU",
    otherLink: "https://youtu.be/nWJXdr0mQ0s?si=emR-z3W3ZxjNxHpN",
  },
  {
    quote: `Just another life to live, just a word to say. Just another love to give, and a diamond day.`,
    author: "Vashti Bunyan",
    authorLink: "https://share.google/oySmlqBcU2DoJcGz4",
    otherLink: "",
  },
  {
    quote: `How we spend our days is, of course, how we spend our lives.`,
    author: "Annie Dillard",
    authorLink: "https://share.google/Fb0uHPqOLRsyLzZ4I",
    otherLink: "",
  },
  {
    quote: `The heart has its reasons which reason knows nothing of.`,
    author: "Blaise Pascal",
    authorLink: "https://share.google/1Tjdh2Hw9pkFlVL2U",
    otherLink: "https://youtu.be/3nb4nYqNXyM?si=QjcCYLR6Q_EDGTgw",
  },
  {
    quote: `How selfish soever man may be supposed, there are evidently some principles in his nature, which him in the fortune of others, and render their happiness necessary to him thoughh e derives nothing it, except the pleasure of seeing it.`,
    author: "Adam Smith",
    authorLink: "https://share.google/w5KKhAU1c8aSLEDy4",
    otherLink: "https://youtu.be/ejJRhn53X2M?si=ZJImXmPl45SpP6b2",
  },
  {
    quote: `Don't hate the player, hate the game.`,
    author: "Ice-T",
    authorLink: "https://share.google/gQe1wcl6pNfLn7Z1J",
    otherLink: "",
  },
  {
    quote: `I'm an optimist in the sense that I believe humans are noble and honorable, and some of them are really smart. I have a somewhate more pessimistic view of people in groups.`,
    author: "Steve Jobs",
    authorLink: "https://share.google/IUhsrIOyuFrpio0zC",
    otherLink: "",
  },
  {
    quote: `Now is better than never. Although never is often better than *right* now`,
    author: "Tim Peters (The Zen of Python)",
    authorLink: "https://en.wikipedia.org/wiki/Zen_of_Python",
    otherLink:
      "https://en.wikipedia.org/wiki/Zen_of_Python#/media/File:Zen_Of_Python.png",
  },
  {
    quote: `The great secret of education is to direct vanity to proper objects.`,
    author: "Adam Smith",
    authorLink: "https://share.google/w5KKhAU1c8aSLEDy4",
    otherLink: "https://youtu.be/ejJRhn53X2M?si=ZJImXmPl45SpP6b2",
  },
  {
    quote: `I am not saying that personal development is more important than winning; on the contrary, I am saying that enjoying the journey of self-discovery, by removing some of the pressure and angst associated with winning at all costs, is one way of helping you to win more often.`,
    author: "Ed Smith",
    authorLink: "https://share.google/OAjt9QHHBW9CFsqod",
    otherLink: "",
  },
  {
    quote: `Money is a good servant, but a bad master.`,
    author: "Francis Bacon",
    authorLink: "https://share.google/DcxbpHZ2BN86ks77u",
    otherLink: "",
  },
  {
    quote: `Kindness in words creates confidence. Kindness in thinking creates profoundness. Kindness in giving creates love.`,
    author: "Lao-Tzu",
    authorLink: "https://share.google/eAXoc4iSKc4zXaPbw",
    otherLink: "",
  },
  {
    quote: `Before you speak, listen. Before you write, think. Before you spend, earn. Before you invest, investigate. Before you criticise, wait. Before you pray, forgive. Before you quit, try. Before you retire, save. Before you die, give.`,
    author: "William A. Ward",
    authorLink: "https://share.google/86ejat4FiXCcMKNGS",
    otherLink: "",
  },
  {
    quote: `It is difficult to get a man to understand something when his salary depends on his not understanding it.`,
    author: "Upton Sinclair",
    authorLink: "https://share.google/mf9hMxRtOQVTEXc3M",
    otherLink: "",
  },
  {
    quote: `We can only be said to be alive in those moments when our hearts are conscious of our treasures`,
    author: "Thornton Wilder",
    authorLink: "https://share.google/Hz3E3qnmyjyfa8vSC",
    otherLink: "",
  },
  {
    quote: `You can be rich by having more than you need, or by needing less than you have.`,
    author: "Jim Mott",
    authorLink: "https://en.wikipedia.org/wiki/James_Mott",
    otherLink: "",
  },
  {
    quote: `Can anybody remember when the times were not hard and money not scarce?`,
    author: "Ralph Waldo Emerson",
    authorLink: "https://share.google/EmYFe8N5X5uD16rOi",
    otherLink: "",
  },
  {
    quote: `I don't believe people are looking for the meaning of life as much as they are looking for the experience of being alive`,
    author: "Joseph Campbell",
    authorLink: "https://share.google/60oQ7vyY6jKc4O93A",
    otherLink: "",
  },
  {
    quote: `No one is free who is not master of himself`,
    author: "Epictetus",
    authorLink: "https://share.google/n22hj2iZPAeuYUxea",
    otherLink: "https://youtu.be/bvYK-IWwKaw?si=iOC0xwQmR-EJFT7u",
  },
  {
    quote: `If we be, therefore, engaged by arguments to put trust in past experience, and make it the standard of our future judgement, these arguments must be probable only`,
    author: "David Hume",
    authorLink: "https://share.google/x8Uz00y49ukoO99zm",
    otherLink: "https://youtu.be/HS52H_CqZLE",
  },
  {
    quote: `Do the difficult things while they are easy and do the great things while they are small.`,
    author: "Lao-Tzu",
    authorLink: "https://share.google/eAXoc4iSKc4zXaPbw",
    otherLink: "",
  },
  {
    quote: `I expect to pass through this world but once. Any good therefore that I can do, or any kindness that I can show to any fellow creature, let me do it now. Let me not defer or neglect it, for I shall not pass this way again.`,
    author: "Stephen Grellet",
    authorLink: "https://share.google/jX3f2RhTtBkVKfRMV",
    otherLink: "",
  },
  {
    quote: `All I ask is the chance to prove that money can't make me happy.`,
    author: "Spike Milligan",
    authorLink: "https://share.google/98iTqQk9KA7VTvO1H",
    otherLink: "",
  },
  {
    quote: `Andy had developed the neurological disease 'Saint Vitus dance' and as a result spent the best part of his eigth year in bed. His mother gave him colouring books to fill in. It was a formative year.`,
    author: "Quote from an Andy Warhol Documentary",
    authorLink: "https://share.google/fIWBACxSSwrjlTnSE",
    otherLink: "https://youtu.be/Dx6tKujAAOY?si=TzXth3rOO04cpJGe&t=619",
  },
  {
    quote: `In order to understand it, I am going to have to draw it.`,
    author: "Art Spiegelman",
    authorLink: "https://share.google/01qPvqXlASjCvh6Sf",
    otherLink: "https://youtu.be/ZkwyZ73_-3k?si=F1lT_yihH3FP54is",
  },
  {
    quote: `The past is never dead, it's not even past.`,
    author: "William Faulkner",
    authorLink: "https://share.google/oWk5t8imCE5DJmslE",
    otherLink: "",
  },
  {
    quote: `Nothing in biology makes sense expect in the light of evolution.`,
    author: "Theodosius Dobzhansky",
    authorLink: "https://share.google/sTIDliyEoX15aI055",
    otherLink: "",
  },
  {
    quote: `Scoring systems are a particularly seductive format for simplified values.`,
    author: "C. Thi Nguyen",
    authorLink: "https://share.google/mgcW9aJXcv5zxmtb7",
    otherLink: "https://share.google/6wwE9XD5zRgCnpx2s",
  },
  {
    quote: `Data is engineered information. Metrics are engineered values.`,
    author: "C. Thi Nguyen",
    authorLink: "https://share.google/mgcW9aJXcv5zxmtb7",
    otherLink: "https://share.google/6wwE9XD5zRgCnpx2s",
  },
  {
    quote: `When the world doesn't force a game and a scoring system on me, I can pick the one tat suits me. I can seek whatever thrills, whatever strange form of beauty, whatever meditative state I want. I have a choice of difficulty. And I can flitter between them with ease.`,
    author: "C. Thi Nguyen",
    authorLink: "https://share.google/mgcW9aJXcv5zxmtb7",
    otherLink: "https://share.google/6wwE9XD5zRgCnpx2s",
  },
  {
    quote: `But if we are indeed in as bad a state as I take us to be, pessimism too will turn out to be one more cultural luxury that we shall have to dispense with in order to survive these hard times.`,
    author: "Alasdair Macintyre",
    authorLink: "https://share.google/b7XlumbfYGKJGu3hS",
    otherLink: "https://share.google/q5g1hsCiMzs7UJRda",
  },
  {
    quote: `There is no better way of forgetting something than by commemorating it.`,
    author: "Alan Bennett (spoken by Irwin, the History Boys)",
    authorLink: "https://share.google/DD6KslLevqI8xKUqn",
    otherLink: "https://share.google/HwJfAbro2SfkykBLB",
  },
  {
    quote: `Pass the parcel. That's sometimes all you can do. Take it, feel it, and pass it on. Not for me. Not for you. But for someone... somewhere... one day. Pass it on boys, that's the game I want you to learn. Pass it on!`,
    author: "Alan Bennett (spoken by Hector, the History Boys)",
    authorLink: "https://share.google/DD6KslLevqI8xKUqn",
    otherLink: "https://share.google/HwJfAbro2SfkykBLB",
  },
  {
    quote: `"With all the ugly sides of our civilisation, I am sure I would rather live as we do now than have to live as the caveman did." Wittgenstein: "Yes, of course you would. But would the caveman?"`,
    author: "Ludwig Wittgenstein",
    authorLink: "https://share.google/RtGEomQYTJg9iC9bB",
    otherLink: "https://www.youtube.com/watch?v=pQ33gAyhg2c",
  },
  {
    quote: `Elvis was a hero to most, but he never meant sh*t to me.`,
    author: "Chuck D",
    authorLink: "https://share.google/bomJHxiSujLE6w1aH",
    otherLink: "https://genius.com/Public-enemy-fight-the-power-lyrics",
  },
  //   {
  //   quote: ``,
  //   author: "",
  //   authorLink: "",
  //   otherLink: "",
  // },
  //   {
  //   quote: ``,
  //   author: "",
  //   authorLink: "",
  //   otherLink: "",
  // },
  //   {
  //   quote: ``,
  //   author: "",
  //   authorLink: "",
  //   otherLink: "",
  // },
];

export default quoteObj;
